var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightDoubleArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.221 15",
    enableBackground: "new 0 0 17.221 15",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0.592,15c-0.061-0.026-0.124-0.049-0.184-0.078c-0.265-0.132-0.402-0.345-0.407-0.642 C0,14.236,0,14.192,0,14.148C0,9.715,0,5.282,0.001,0.849c0-0.097-0.003-0.197,0.018-0.291C0.128,0.059,0.727-0.165,1.14,0.137 C1.199,0.18,1.251,0.232,1.303,0.283c2.21,2.209,4.419,4.418,6.628,6.628c0.387,0.387,0.387,0.787,0.001,1.173 c-2.185,2.185-4.371,4.37-6.554,6.557C1.225,14.795,1.068,14.936,0.856,15C0.768,15,0.68,15,0.592,15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.592,15c-0.061-0.026-0.124-0.049-0.184-0.078c-0.265-0.132-0.402-0.345-0.407-0.642 C9,14.236,9,14.192,9,14.148C9,9.715,9,5.282,9.001,0.849c0-0.097-0.003-0.197,0.018-0.291c0.109-0.499,0.709-0.723,1.121-0.421 c0.059,0.043,0.111,0.095,0.163,0.147c2.21,2.209,4.419,4.418,6.628,6.628c0.387,0.387,0.387,0.787,0.001,1.173 c-2.185,2.185-4.371,4.37-6.554,6.557c-0.153,0.153-0.31,0.295-0.522,0.359C9.768,15,9.68,15,9.592,15z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDoubleArrow);
export default __webpack_public_path__ + "static/media/right-double-arrow.7270a711d4a28444cffac4ed02424e4b.svg";
export { ForwardRef as ReactComponent };